export default __webpack_public_path__ + "static/media/Untitled-1.7744e609.jpg";